const Style = {
    container: 'flex flex-col p-4 px-8 space-y-4',
    btn: 'text-md w-fit mx-auto min-w-[150px]',
}

export default Style